// src/utils/RequireVendor.js
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { db } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { Navigate, useLocation } from "react-router-dom";

export default function RequireVendor({ children, requireApproved = true }) {
  const auth = getAuth();
  const [state, setState] = useState({ ready: false, ok: false, reason: "" });
  const loc = useLocation();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) {
        setState({ ready: true, ok: false, reason: "noauth" });
        return;
      }
      try {
        const v = await getDoc(doc(db, "vendors", u.uid));
        if (!v.exists()) {
          setState({ ready: true, ok: false, reason: "notregistered" });
          return;
        }
        const data = v.data();
        if (requireApproved && data.status !== "approved") {
          setState({ ready: true, ok: false, reason: "pending" });
          return;
        }
        setState({ ready: true, ok: true, reason: "" });
      } catch (e) {
        setState({ ready: true, ok: false, reason: "error" });
      }
    });
    return () => unsub();
  }, []);

  if (!state.ready) return null;

  const redirect = encodeURIComponent(loc.pathname + loc.search);
  if (!state.ok) {
    if (state.reason === "noauth") {
      return <Navigate to={`/tender?tab=login&redirect=${redirect}`} replace />;
    }
    if (state.reason === "notregistered") {
      return <Navigate to={`/tender?tab=register&redirect=${redirect}`} replace />;
    }
    if (state.reason === "pending") {
      return (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="bg-white border rounded-xl p-6 text-center">
            <div className="text-lg font-semibold text-emerald-700">
              Approval Pending
            </div>
            <p className="text-sm text-gray-600 mt-2">
              Your vendor account is awaiting admin approval.
            </p>
          </div>
        </div>
      );
    }
    return <Navigate to={`/tender?tab=register&redirect=${redirect}`} replace />;
  }

  return children;
}
